import React from "react";
import "../../../AllComponentCSS.css";

function JS_forEach() {
  return (
    <div className="tutorial-page">
      <h1>JS forEach</h1>
      <p>This page will cover the forEach topic in detail.</p>
    </div>
  );
}

export default JS_forEach;
